import { Operator } from '../../../components/Module/Table/Filters/FilterInput/constants';
import { FilterParam, IFilterSearchParams } from './types';

export class FilterSearchParams implements IFilterSearchParams {
  private _value: FilterParam[];

  constructor(initialValue?: FilterParam[]) {
    this._value = initialValue || [];
  }

  get size() {
    return this._value.length;
  }

  /** Удаляет параметры фильтра, соответствующие указанным критериям. */
  delete = (field: string, value?: string, operator?: Operator): void => {
    this._value = this._value.filter((v) => {
      if (v.field !== field) return true;
      if (operator !== undefined && v.operator !== operator) return true;
      if (value !== undefined && v.value !== value) return true;

      return false;
    });
  };

  /** Добавляет новый параметр фильтра в коллекцию. */
  append = (field: string, value: string, operator?: Operator): void => {
    this._value.push({ field, value, operator });
  };

  /** Устанавливает параметр фильтра, заменяя существующий с совпадающими критериями. */
  set = (field: string, value: string, operator?: Operator): void => {
    this.delete(field, undefined, operator);
    this.append(field, value, operator);
  };

  /** Получает первый параметр фильтра, соответствующий указанным критериям. */
  get = (field: string, operator?: Operator): FilterParam | undefined => {
    return this._value.find((v) => {
      if (v.field !== field) return false;
      if (operator !== undefined && v.operator !== operator) return false;

      return true;
    });
  };

  /** Получает все параметры фильтра, соответствующие указанным критериям. */
  getAll = (field: string, operator?: Operator): FilterParam[] => {
    return this._value.filter((v) => {
      if (v.field !== field) return false;
      if (operator !== undefined && v.operator !== operator) return false;

      return true;
    });
  };

  /** Проверяет наличие параметра фильтра с указанными критериями. */
  has = (field: string, value?: string, operator?: Operator): boolean => {
    return this._value.some((v) => {
      if (v.field !== field) return false;
      if (operator !== undefined && v.operator !== operator) return false;
      if (value !== undefined && v.value !== value) return false;

      return true;
    });
  };

  /** Проверяет, содержит ли коллекция все указанные параметры фильтра. */
  includes = (value: FilterParam[]) => {
    if (value.length === 0) return true;

    if (value.length > this._value.length) return false;

    return value.every((external) => {
      return this._value.some(
        (internal) =>
          internal.field === external.field &&
          internal.value === external.value &&
          internal.operator === external.operator,
      );
    });
  };

  /** Предоставляет итератор для перебора всех параметров фильтра. */
  *entries(): IterableIterator<FilterParam> {
    for (const { field, value, operator } of this._value) {
      yield { field, value, operator };
    }
  }

  /** Преобразует коллекцию параметров фильтра в строку query-параметров. */
  toString = (group?: string): string => {
    return this._value
      .map(({ field, value, operator }) => {
        if (field === '' || value === '') return '';

        const hasGroup = group !== undefined && group !== '';
        const prefix = hasGroup ? '_' + group + '__' : '';
        const postfix = !!operator ? '__' + operator : '';

        return `${prefix}${field}${postfix}=${value}`;
      })
      .join('&');
  };
}
